"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var EventsManager = /** @class */ (function () {
    function EventsManager(ideal, retryTimes, retryIdeal, apiCallFunc) {
        this.ideal = ideal;
        this.retryTimes = retryTimes;
        this.retryIdeal = retryIdeal;
        this.apiCallFunc = apiCallFunc;
    }
    EventsManager.prototype.setEventStore = function (eventStore) {
        this.eventStore = eventStore;
    };
    EventsManager.prototype.flushEvents = function () {
        var _this = this;
        var _a;
        if (!((_a = this.eventStore) === null || _a === void 0 ? void 0 : _a.isEmpty())) {
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            this.sendOut(this.eventStore.popEvents())
                .then(function () {
                var _a;
                (_a = _this.eventStore) === null || _a === void 0 ? void 0 : _a.onSuccess();
            })
                .catch(function () {
                var _a;
                (_a = _this.eventStore) === null || _a === void 0 ? void 0 : _a.onFailed();
            });
        }
    };
    EventsManager.prototype.startTimer = function () {
        var _this = this;
        if (this.enableBatching) {
            this.timer = window.setTimeout(function () {
                _this.flushEvents();
                _this.resetTimer();
            }, this.ideal);
        }
    };
    EventsManager.prototype.resetTimer = function () {
        if (this.enableBatching) {
            window.clearTimeout(this.timer);
            this.startTimer();
        }
    };
    EventsManager.prototype.sendOut = function (events) {
        var _this = this;
        return this.retry(function () { return _this.apiCallFunc(events); }, this.retryTimes);
    };
    EventsManager.prototype.retry = function (funcCall, retryTimes) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            try {
                funcCall()
                    .then(resolve)
                    .catch(function () {
                    if (retryTimes > 0) {
                        setTimeout(function () {
                            _this.retry(funcCall, retryTimes - 1);
                        }, _this.retryIdeal);
                    }
                    else {
                        reject("Still failed after " + _this.retryTimes + " times retry");
                    }
                });
            }
            catch (e) {
                console.error(e);
            }
        });
    };
    return EventsManager;
}());
exports.default = EventsManager;
//# sourceMappingURL=EventsManager.js.map